import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { makeStyles } from "@material-ui/core/styles";
import SvgIcon from '@material-ui/core/SvgIcon';
import UserIcon from '../../../../icons/user1.svg';
import CheckIcon from '@material-ui/icons/Check';

import './HelpSection.scss'

export default function HelpSection(props) {

  const useStyles = makeStyles(theme => ({
    divider: {
      borderTop: `5px solid ${theme.palette.primary.main}`,
      marginTop: 30
    }
  }));

  const classes = useStyles();

  return (
    <div className="help-section">
      <hr className={classes.divider}></hr>
      <div >
        <h4>Questions? Need help?</h4>
        <h5>We're here to help. Ask us anything.</h5>
        <Row className="mt-4 d-flex justify-content-center">
          <Col xs="auto" className="">
            <SvgIcon component={UserIcon} fontSize="large" color="primary" className="my-0" />
          </Col>
          <Col xs="auto" sm={7} md={8} className="p-0">
            <h5>Our Experts</h5>
            <ul className="p-0">
              <li><CheckIcon color="primary" className="mr-1" />Licensed in all 50 states</li>
              <li><CheckIcon color="primary" className="mr-1" />Salaried employees</li>
              <li><CheckIcon color="primary" className="mr-1" />Provide personalized service</li>
              <li><CheckIcon color="primary" className="mr-1" />Knowledgeable &amp; friendly</li>
            </ul>
          </Col>
        </Row>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Appointment/HelpSection.js